export default "__VITE_ASSET__wJ9ar7tK__"